import { gql } from '@apollo/client';
import { VESSEL_FRAGMENT } from '../fragments/vesselFragment';

//comment

export const SEARCH_VESSELS = gql`
    query Vessels(
        $searchTerm: String!
        $datasetId: Int!
        $minCapacity: Int!
        $maxCapacity: Int!
        $searchVesselsWithImoOnly: Boolean!
        $division: Int!
    ) {
        vessels(
            searchTerm: $searchTerm
            datasetId: $datasetId
            minCapacity: $minCapacity
            maxCapacity: $maxCapacity
            searchVesselsWithImoOnly: $searchVesselsWithImoOnly
            division: $division
        ) {
            vesselId
            imo
            shipsBaseTankerVesselId
            name
            dwt
            tankTypeCode
            gasCbm
            yob
            scrubber
            yard
            design
            imoClass {
                imoGradeI
                imoGradeII
                imoGradeIII
            }
            iceClassNotation
            grades
            nitrogenPlant
            bestOperator
            gainCompany {
                value
                partType
                name
            }
            eniNumber
            fleetTypeIds
            isTbn
            gasType
            engineType
            propType
            builtDate
            alternativeFuelType
        }
    }
`;

export const VESSEL_POSITION_QUERY = gql`
    query VesselPositions($imo: Int!) {
        vesselPositions(imo: $imo) {
            firstSeen
            draft
            speed
            distanceToPort
            nearestPort
        }
    }
`;

export const GET_VESSEL_BY_IMO_QUERY = gql`
    query VesselByImo($datasetId: Int!, $imo: Int!, $division: Int!) {
        vesselByImo(datasetId: $datasetId, imo: $imo, division: $division) {
            vesselId
            imo
            shipsBaseTankerVesselId
            name
            dwt
            tankTypeCode
            gasCbm
            yob
            scrubber
            yard
            design
            imoClass {
                imoGradeI
                imoGradeII
                imoGradeIII
            }
            iceClassNotation
            grades
            nitrogenPlant
            bestOperator
            gainCompany {
                value
                partType
                name
            }
            eniNumber
            fleetTypeIds
            isTbn
            gasType
            engineType
            propType
            builtDate
            alternativeFuelType
        }
    }
`;
